import fetch from './fetch';

export default ({ email }: { email: string }): Promise<void> =>
    fetch<void>('/forgot-password', {
        method: 'POST',
        body: JSON.stringify({
            email,
        }),
    });

export const setNewPassword = ({
    email,
    confirmationCode,
    password,
}: {
    email: string;
    confirmationCode: string;
    password: string;
}): Promise<void> =>
    fetch<void>('/confirm-forgot-password', {
        method: 'POST',
        body: JSON.stringify({
            email,
            confirmationCode,
            password,
        }),
    });
